import { Fragment } from "react";

function Card(props) {
  return (
    <Fragment>
      {props.result && (
        <div className="infoQuestions goodNews">
          <h2>
            <span className="mFont">celebration</span>
            <br />
            {props.message}
          </h2>
        </div>
      )}

      {!props.result && (
        <div className="infoQuestions badNews">
          <h2>
            <span className="mFont">sentiment_very_dissatisfied</span>
            <br />
            {props.message}
          </h2>
        </div>
      )}
    </Fragment>
  );
}

export default Card;
